import { billingExportPath } from './constants';
import { baseAutomationUrl } from 'src/config';
import { getAccessToken, getRealmName } from 'src/routes/AuthContext';
import { TBillingExportPullBody } from './types';
import axios from 'axios';
import { getClientIpHeader } from 'src/services/clientIpService/getClientIp';

/**
 * Downloads the closed period's billing export as a ZIP. An error body arrives as bytes too, so
 * callers cannot read a server message off a failure and fall back to generic copy.
 */
export const getPullBillingExport = async (body: TBillingExportPullBody) => {
  const token = await getAccessToken();
  const realm = getRealmName() ?? '';
  const getFacilityUuid = localStorage.getItem('facilityId');

  if (getFacilityUuid && getFacilityUuid.length) {
    body.facility_uuid = getFacilityUuid;
  }

  body.enterprise_name = realm;
  body.batch_type = 'BILLING';

  const url = `${baseAutomationUrl}${billingExportPath.PULL_BILLING_EXPORT}`;

  return axios.post(url, body, {
    headers: {
      Authorization: `Bearer ${token}`,
      ...(await getClientIpHeader()),
    },
    responseType: 'arraybuffer',
  });
};
